class StateSelector extends HTMLElement {

    connectedCallback() {
        console.log("StateSelector connected");
        this.dropdownSelected = this.querySelector('.state-dropdown__selected');
        this.dropdownList     = this.querySelector('.state-dropdown__list');
        this.label            = this.querySelector('.state-label');
        this.items            = this.querySelectorAll('.state-dropdown__item');
        this.searchInput      = this.querySelector('.state-dropdown__search');

        if (!this.label) {
            console.warn("StateSelector: .state-label not found");
            return;
        }

        const saved = window.StateLogic?.getState?.();

        if (saved) {
            this.label.textContent = saved;
        } else {
            this.detectAndApplyRegion();
        }


        this.dropdownSelected.addEventListener('click', () => {
            this.dropdownList.classList.toggle('open');
            this.searchInput.value = "";
            this.filterStates("");
            this.searchInput.focus();
        });

        this.items.forEach(item => {
            item.addEventListener('click', () => {
                const state = item.dataset.state;
                this.label.textContent = state;
                this.dropdownList.classList.remove('open');

                if (window.StateLogic?.setState) {
                    window.StateLogic.setState(state);
                }
            });
        });

        this.searchInput.addEventListener('input', () => {
            this.filterStates(this.searchInput.value);
        });

        document.addEventListener('click', (e) => {
            if (!this.contains(e.target)) {
                this.dropdownList.classList.remove('open');
            }
        });
    }

    filterStates(query) {
        const q = query.toLowerCase();
        this.items.forEach(item => {
            const match = item.dataset.state.toLowerCase().includes(q);
            item.style.display = match ? "block" : "none";
        });
    }


    // detectAndApplyRegion() {

    //     fetch("https://ipwho.is/")
    //         .then(res => res.json())
    //         .then(data => {

    //             console.log("Geo response:", data);

    //             if (!data || !data.region) {
    //                 return this.setDefaultLabel();
    //             }

    //             const region = data.region.trim().toLowerCase();

    //             if (this.allStates.includes(region)) {
    //                 const pretty = this.capitalize(region);
    //                 this.label.textContent = pretty;

    //                 if (window.StateLogic?.setState) {
    //                     window.StateLogic.setState(pretty);
    //                 }
    //             } else {
    //                 console.log("Region NOT a US state → fallback");
    //                 this.setDefaultLabel();
    //             }

    //         })
    //         .catch(err => {
    //             console.warn("Geo detection failed:", err);
    //             this.setDefaultLabel();
    //         });
    // }
    detectAndApplyRegion() {
        const geo = window.StateLogic?.detectRegion?.();
        if (!geo) return this.setDefaultLabel();

        geo.then(region => {
            // A state may have been picked (or applied by another selector) meanwhile.
            if (window.StateLogic?.getState?.()) return;

            const match = region && Array.from(this.items).find(
                i => i.dataset.state.trim().toLowerCase() === region.toLowerCase()
            );

            if (match) {
                window.StateLogic.setState(match.dataset.state.trim());
            } else {
                this.setDefaultLabel();
            }
        }).catch(() => this.setDefaultLabel());
    }


    setDefaultLabel() {
        this.label.textContent = "Select your state";
    }
}

customElements.define('state-selector', StateSelector);
